import axios from "axios";
const jsonConfig = require("../Config.json");



const addNewSkillResponse = async (skillData) => {
  try {
    const getAllResponse = await axios.post(
      jsonConfig.apiUrl + "skills",
      skillData,
      {
        headers: {
          "x-functions-key": jsonConfig.key,
        },
      }
    );
    return Promise.resolve(getAllResponse);
  } catch (error) {
    return Promise.reject(error);
  }
};
export default addNewSkillResponse;
